const API_ROOT = process.env.API_ROOT;
const PPM_API_ROOT = process.env.PPM_API_ROOT;
const NODE_ENV = process.env.NODE_ENV;
const PartnerCenterUrl = process.env.PartnerCenterUrl;

export {
	API_ROOT,
	PPM_API_ROOT,
	NODE_ENV,
    PartnerCenterUrl
};